// @flow

const POLICY = 'Полис ДМС';
const NOTIFICATIONS = 'Уведомления';
const SERVICES = 'Оказанные услуги';
const MEDICAL_TYPES = 'Виды медпомощи';
const SEND_REQUEST = 'Заявки';
const MEDICAL_OFFICES = 'Клиники';
const PROGRAM_INSURANCE = 'Программа и условия страхования';
const FAMILY_INSURANCE = 'Страхование родственников';
const UPGRADE_PROGRAM = 'Улучшить программу';
const FRANCHISE = 'Франшиза';
const MEDICAL_CARE = 'Цифровая клиника';


const TABS_NAME_DMS = {
	POLICY,
	SERVICES,
	SEND_REQUEST,
	NOTIFICATIONS,
	MEDICAL_TYPES,
	PROGRAM_INSURANCE,
	MEDICAL_OFFICES,
	FRANCHISE,
	FAMILY_INSURANCE,
	UPGRADE_PROGRAM,
	MEDICAL_CARE,
};


const TABS_KEYS = {
	POLICY: 'policy-info',
	SERVICES: 'services',
	SEND_REQUEST: 'send-request',
	MEDICAL_TYPES: 'medical-types',
	NOTIFICATIONS: 'notifications',
	PROGRAM_INSURANCE: 'program-insurance',
	MEDICAL_OFFICES: 'available-offices',
	FRANCHISE: 'franchise',
	FAMILY_INSURANCE: 'family-insurance',
	UPGRADE_PROGRAM: 'upgrade-program',
	MEDICAL_CARE: 'medical-aid',
	TELEMEDICINE: 'telemedicine',
	AGREE_ON_MEDICAL_SERVICE: 'agree-on-medical-service',
	ARRANGE_VISIT: 'arrange-visit',
	CALLING_DOCTOR: 'calling-doctor',
	PLANNED_HOSPITALIZATION: 'planned-hospitalization',
	MEDICAL_REQUEST: 'medical-request',
	CES_SURVEY: 'survey',
	AMBULANCE_MAP: 'ambulance-map',
	CRITICAL_ILLNESS_INSURANCE: 'critical-illness-insurance',
	CANCER_INSURANCE: 'cancer-insurance',
	MITE_INSURANCE: 'mite-insurance',
	LABORATORY_RESEARCH: 'laboratory-research',
	TELEMED_HUB: 'telemed-hub',
};

const VIEW_MODE_KEYS = {
	LIST: 'list',
	MAP: 'map',
};

const VIEW_KEYS = {
	MEDICAL_OFFICES_LIST: `${TABS_KEYS.MEDICAL_OFFICES}/${VIEW_MODE_KEYS.LIST}`,
	MEDICAL_OFFICES_MAP: `${TABS_KEYS.MEDICAL_OFFICES}/${VIEW_MODE_KEYS.MAP}`,
};

const VIEW_MODELS = {
	DMS_PAGE_MODEL: 'DMS_PAGE_MODEL',
	DMS_MEDICAL_TYPES: "MEDICAL_TYPES",
	DMS_MEDICAL_OFFICES_MODEL: 'DMS_MEDICAL_OFFICES_MODEL',
	DMS_POLICY_MODEL: 'DMS_POLICY_MODEL',
	DMS_SEND_REQUEST_MODEL: 'DMS_SEND_REQUEST_MODEL',
	DMS_INSURANCE_PROGRAMS: 'DMS_INSURANCE_PROGRAMS',
	DMS_NOTIFICATIONS_MODEL: 'DMS_NOTIFICATIONS_MODEL',
	DMS_SERVICES_MODEL: 'DMS_SERVICES_MODEL',
	DMS_FRANCHISE_MODEL: 'FRANCHISE_MODEL',
	DMS_FAMILY_INSURANCE_MODEL: 'DMS_FAMILY_INSURANCE_MODEL',
	DMS_UPGRADE_PROGRAM_MODEL: 'DMS_UPGRADE_PROGRAM_MODEL',
	DMS_MEDICAL_CARE: 'DMS_MEDICAL_CARE_MODEL',
	DMS_TELEMEDICINE_MODEL: 'DMS_TELEMEDICINE_MODEL',
	DMS_AGREE_ON_MEDICAL_SERVICE_MODEL: 'DMS_AGREE_ON_MEDICAL_SERVICE_MODEL',
	DMS_ARRANGE_VISIT_MODEL: 'DMS_ARRANGE_VISIT_MODEL',
	DMS_CALLING_DOCTOR_MODEL: 'DMS_CALLING_DOCTOR_MODEL',
	PLANNED_HOSPITALIZATION_MODEL: 'PLANNED_HOSPITALIZATION_MODEL',
	DMS_MEDICAL_REQUEST_MODEL: 'DMS_MEDICAL_REQUEST_MODEL',
	DMS_CES_SURVEY: 'DMS_CES_SURVEY',
	DMS_AMBULANCE_MAP: 'DMS_AMBULANCE_MAP',
	DMS_LABORATORY_RESEARCH_MODEL: 'DMS_LABORATORY_RESEARCH_MODEL',
	DMS_TELEMED_HUB_MODEL: 'DMS_TELEMED_HUB_MODEL',
};

const PAGE_RESOLVER_KEY = 'page-resolver-key';

const QUERIES = {
	PHONE_CONFIRMED: 'phone-confirmed',
	AGREEMENT_ACCEPTED: 'agreement-accepted',
};

export {
	TABS_NAME_DMS,
	TABS_KEYS,
	VIEW_MODE_KEYS,
	VIEW_KEYS,
	VIEW_MODELS,
	QUERIES,
	PAGE_RESOLVER_KEY,
};
